import { Button } from "../../../components/ui/button";
import { Badge } from "../../../components/ui/badge";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faEnvelope,
  faPhone,
  faStore,
  faCalendarAlt,
  // faEdit,
  faCheckCircle,
  faTimesCircle,
  faClock,
  faUserCircle,
  faBuilding,
  faUserTie,
} from "@fortawesome/free-solid-svg-icons";
import Modal from "../../../components/ui/modal";

const SellerDetails = ({ seller, onClose, onEdit }) => {
  const getStatusBadge = (status) => {
    const config = {
      Active: {
        className: "bg-green-600 text-white border-green-200",
        icon: faCheckCircle,
        iconColor: "text-green-600",
        bgColor: "bg-whte",
        borderColor: "border-slate-200",
        dotColor: "bg-green-500",
      },
      Inactive: {
        className: "bg-red-500 text-white border-red-200",
        icon: faTimesCircle,
        iconColor: "text-red-500",
        bgColor: "bg-white",
        borderColor: "border-slate-200",
        dotColor: "bg-red-500",
      },
      Pending: {
        className: "bg-yellow-100 text-yellow-700 border-yellow-200",
        icon: faClock,
        iconColor: "text-yellow-500",
        bgColor: "bg-yellow-50",
        borderColor: "border-yellow-200",
        dotColor: "bg-yellow-500",
      },
    };
    return config[status] || config.Active;
  };

  const formatDate = (date) => {
    if (!date) return "-";
    return new Date(date).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const status = getStatusBadge(seller?.status);

  // Info Item Component
  const InfoItem = ({ icon, label, value, highlight = false }) => (
    <div
      className={`flex items-start gap-3 p-3 rounded-md border transition-all duration-200 ${
        highlight
          ? "bg-blue-50 border-blue-200 shadow-sm"
          : "bg-gray-50 border-gray-200 hover:bg-gray-100 hover:border-gray-200"
      }`}
    >
      <div
        className={`w-9 h-9 rounded-lg flex items-center justify-center shrink-0 ${
          highlight ? "bg-blue-100" : "bg-white border border-gray-200"
        }`}
      >
        <FontAwesomeIcon
          icon={icon}
          className={`h-4 w-4 ${highlight ? "text-blue-600" : "text-gray-600"}`}
        />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm uppercase tracking-wider text-gray-600 font-semibold">
          {label}
        </p>
        <p
          className={`text-sm font-medium truncate ${highlight ? "text-blue-700" : "text-gray-900"}`}
        >
          {value || "-"}
        </p>
      </div>
    </div>
  );

  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      title={
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-600 to-indigo-600 flex items-center justify-center shadow-md">
            <FontAwesomeIcon icon={faUserTie} className="text-white h-5 w-5" />
          </div>
          <div>
            <h3 className="text-lg font-bold text-gray-900">Seller details</h3>
            <p className="text-sm text-gray-600 font-medium">
              View and manage shop seller information
            </p>
          </div>
        </div>
      }
      maxWidth="sm:max-w-2xl"
      footer={
        <div className="flex flex-col-reverse sm:flex-row justify-end gap-3">
          <Button
            variant="outline"
            onClick={onClose}
            className="w-full sm:w-auto px-6 border-2 border-orange-700 text-red-600 hover:text-white hover:bg-orange-600 hover:border-none"
          >
            Close
          </Button>
          {/* <Button
            onClick={() => {
              onClose();
              onEdit(seller);
            }}
            className="gap-2 w-full sm:w-auto bg-blue-800 hover:from-blue-700 hover:to-blue-900 text-white px-6 shadow-md hover:shadow-lg transition-all duration-200"
          >
            <FontAwesomeIcon icon={faEdit} className="h-4 w-4" />
            Edit seller
          </Button> */}
        </div>
      }
    >
      {seller && (
        <div className="flex flex-col gap-5">
          {/* Profile Header - Like Job Post Header */}
          <div className="relative overflow-hidden rounded-lg bg-gradient-to-r from-blue-600 to-indigo-700 p-6 text-white">
            <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/3"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/5 rounded-full translate-y-1/2 -translate-x-1/3"></div>

            <div className="relative z-10 flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <div className="w-16 h-16 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center border-2 border-white/30 shadow-lg">
                <FontAwesomeIcon
                  icon={faUserCircle}
                  className="text-white h-8 w-8"
                />
              </div>
              <div className="flex-1">
                <h3 className="text-xl font-bold">{seller.name}</h3>
                <div className="flex flex-wrap items-center gap-2 mt-1.5">
                  <Badge className="bg-white/20 text-white border-white/30 backdrop-blur-sm text-sm px-3 py-1">
                    <FontAwesomeIcon
                      icon={faBuilding}
                      className="mr-1.5 h-3 w-3"
                    />
                    {seller.shopName?.split("-")[0] || "Shop"}
                  </Badge>
                </div>
              </div>
            </div>
          </div>

          {/* Information Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <InfoItem
              icon={faUser}
              label="Full Name"
              value={seller.name}
              highlight={true}
            />

            <InfoItem
              icon={faEnvelope}
              label="Email Address"
              value={seller.email}
            />

            <InfoItem
              icon={faPhone}
              label="Phone Number"
              value={seller.phone}
            />

            <InfoItem icon={faStore} label="Shop" value={seller.shopName} />

            <InfoItem
              icon={faCalendarAlt}
              label="Joined Date"
              value={formatDate(seller.joinedDate)}
            />
            <div
              className={`rounded-lg p-4 ${status.bgColor} border ${status.borderColor}`}
            >
              <div className="flex items-center justify-between flex-wrap gap-2">
                <div className="flex items-center gap-3">
                  <div className="relative">
                    <span
                      className={`inline-block w-3 h-3 rounded-full ${status.dotColor} animate-pulse`}
                    ></span>
                    <FontAwesomeIcon
                      icon={status.icon}
                      className={`h-4 w-4 ${status.iconColor} absolute -top-1 -right-1 bg-white rounded-full p-0.5`}
                    />
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-gray-900">
                      Status:{" "}
                      <span className={status.iconColor}>{seller.status}</span>
                    </p>
                    <p className="text-xs text-gray-600">
                      {seller.status === "Active"
                        ? "Currently working at the shop"
                        : seller.status === "Pending"
                          ? "Awaiting activation"
                          : "Not currently active"}
                    </p>
                  </div>
                </div>
                <Badge
                  variant="outline"
                  className={`${status.className} text-sm font-medium px-3 py-1`}
                >
                  {seller.status}
                </Badge>
              </div>
            </div>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default SellerDetails;
